import { useState } from "react";
import { requirementTabs } from "@/mocks/home";

export default function SystemRequirements() {
  const [activeTab, setActiveTab] = useState(requirementTabs[0].key);
  const current = requirementTabs.find((tab) => tab.key === activeTab) ?? requirementTabs[0];

  return (
    <section id="requirements" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-start">
          <div>
            <span className="text-xs font-label tracking-widest text-primary-700">REQUIREMENTS</span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              安装前，先确认设备配置
            </h2>
            <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
              切换下方标签查看不同平台的配置要求。若设备低于最低系统版本，可能会在安装或运行阶段出现问题，
              建议先升级系统再尝试安装。
            </p>

            <div className="mt-6 inline-flex p-1 rounded-full bg-background-100 border border-background-200 gap-1">
              {requirementTabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setActiveTab(tab.key)}
                  aria-pressed={activeTab === tab.key}
                  className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    activeTab === tab.key
                      ? "bg-primary-600 text-background-50"
                      : "text-foreground-700 hover:text-primary-700"
                  }`}
                >
                  <i className={tab.icon}></i>
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
            <ul className="space-y-4">
              {current.items.map((item) => (
                <li key={item.title} className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-xs">
                    <i className="ri-check-double-line"></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-950">{item.title}</h3>
                    <p className="mt-0.5 text-sm leading-6 text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}